/**
 *  Line
 * @author Nicolas Venne
 *
 * @copyright Klipfolio, All rights reserved
 */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { parseMarginOrPadding } from '@helpers'

const LineComponent = ({ className, ...rest }) => {
  return <hr className={className} {...rest} />
}

LineComponent.propTypes = {
  className: PropTypes.string
}

const Line = styled(LineComponent)`
  margin: ${({ margin }) => parseMarginOrPadding(margin)};
  height: 1px;
  border: 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.background['300']};
`
export default Line
